import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import RankingSection from '@/pages/home/components/RankingSection';
import LatestSection from '@/pages/home/components/LatestSection';
import GenreSection from '@/pages/home/components/GenreSection';
import EditorSection from '@/pages/home/components/EditorSection';
import GuideSection from '@/pages/home/components/GuideSection';
import FaqSection from '@/pages/home/components/FaqSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <FeaturedSection />
        <RankingSection />
        <LatestSection />
        <GenreSection />
        <EditorSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}